import { GetStaticPaths, GetStaticPropsContext } from 'next'
import { useTranslation } from 'next-i18next'

import { Fragment } from 'react'

import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import SelectGradePage from '~/bootcamp/pages/SelectGrade.page'
import curriculumSanity from '~/shared/sanity/curriculum'
import Metatags from '~/components/Metadata/Metatags'
import { GetProps } from '~/utils/pageWrapper/types'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { setGradeListByCountryActionCreator } from '~/curriculum/slice/curriculum.slice'
import { Tab } from '~/curriculum/components/SelectToggle'
import { isParamsCountryCodeValid } from '~/curriculum/utils/validateCountryCodeGrade'

export default function SelectGrade(): React.ReactElement {
  const { t } = useTranslation('onboarding')

  return (
    <Fragment>
      <Metatags noindex title={t('curriculum.selectGrade')} />
      <SelectGradePage defaultTab={Tab.GRADE} />
    </Fragment>
  )
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export const getProps: GetProps =
  (store) =>
  async ({ params }: GetStaticPropsContext<{ countryCode: string }>) => {
    const countryCodeWithGradeLabel = params?.countryCode as string

    if (!isParamsCountryCodeValid(countryCodeWithGradeLabel)) {
      return {
        notFound: true,
      }
    }

    const countryCode = countryCodeWithGradeLabel.split('-')[1]

    const gradeList = await curriculumSanity.getCurriculumGradeListByCountry(countryCode, 'v1')
    store.dispatch(setGradeListByCountryActionCreator(gradeList))

    return {
      props: {
        path: `/bootcamp/select-grade/${countryCodeWithGradeLabel}`,
        namespaces: [...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES, 'curriculum'],
      },
      revalidate: process.env.ENVIRONMENT === 'staging' ? 60 : false,
    }
  }

export const getStaticProps = getStaticPropsWrapper(getProps)
